export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0050.ab10eeea.webp";